export enum IPricingTrialBannerKey {
  TRIAL_LAST_DAY = 'TRIAL_LAST_DAY',
}

export enum IPricingCampaignsBannerKey {
  CAMPAIGN_GROUP_TEMPLATE_LAST_2_DAYS = 'CAMPAIGN_GROUP_TEMPLATE_LAST_2_DAYS',
  CAMPAIGN_TEMPLATE_LAST_2_DAYS = 'CAMPAIGN_TEMPLATE_LAST_2_DAYS',
  CAMPAIGN_GROUP_TEMPLATE_NOT_ENABLED = 'CAMPAIGN_GROUP_TEMPLATE_NOT_ENABLED',
  CAMPAIGN_TEMPLATE_OVER_LIMIT = 'CAMPAIGN_TEMPLATE_OVER_LIMIT',
  CAMPAIGN_TEMPLATE_REACHED_LIMIT = 'CAMPAIGN_TEMPLATE_REACHED_LIMIT',
}

export enum IPricingBillingBannerKey {
  /**
   * @use [Billing Summary, Dashboard]
   */
  BILLING_FAILED_BEFORE_THRESHOLD_DAY = 'BILLING_FAILED_BEFORE_THRESHOLD_DAY',
  /**
   * @use [Billing Summary, Dashboard, Page Analytics, Campaign Listing]
   */
  BILLING_FAILED_AFTER_THRESHOLD_DAY = 'BILLING_FAILED_AFTER_THRESHOLD_DAY',
  /**
   * @use [Billing Summary, Dashboard, Page Analytics, Campaign Listing]
   */
  BILLING_FAILED_SHOPIFY_PAYMENT = 'BILLING_FAILED_SHOPIFY_PAYMENT',
  /**
   * @use [Billing Summary, Dashboard, Page Analytics, Campaign Listing]
   */
  BILLING_FAILED_BLOCKED_APP = 'BILLING_FAILED_BLOCKED_APP',

  // SUCCESS
  BILLING_ISSUED_TO_SHOPIFY = 'BILLING_ISSUED_TO_SHOPIFY',
}

export enum IPricingBillingVariant {
  DASHBOARD = 'DASHBOARD',
  PRICING = 'PRICING',
  PAGE_ANALYTICS = 'PAGE_ANALYTICS',
  CAMPAIGN_LISTING = 'CAMPAIGN_LISTING',
  BILLING_SUMMARY = 'BILLING_SUMMARY',
}

export enum IPricingPageAnalyticBannerKey {
  ENJOY_UNLIMITED = 'ENJOY_UNLIMITED',
}

const PRICING_BANNER_KEYS = {
  ...IPricingTrialBannerKey,
  ...IPricingCampaignsBannerKey,
  ...IPricingPageAnalyticBannerKey,
  ...IPricingBillingBannerKey,
};

export type PricingBannerKey = keyof typeof PRICING_BANNER_KEYS;
